/* Naudet (ClaudIA) — 2026-08-27, demande Denis : les liens vers d'AUTRES SITES
   doivent s'ouvrir dans un nouvel onglet. Constate en seance : ils remplacaient la
   page courante, donc le visiteur quittait la boutique et perdait sa navigation.

   Mesure du 27/08 avant correctif : 15 liens externes sur 4 pages seulement
   (Google Maps, reseauexcellence.fr, exploreparis.com, lemonde.fr, fichiers CDN).

   POURQUOI UNE REGLE GENERALE PLUTOT QUE LIEN PAR LIEN
   Le theme offre bien une case « Ouvrir le lien dans un nouvel onglet » sur les blocs
   bouton / carte / icone / groupe (reglage open_in_new_tab, DECOCHE par defaut), mais
   elle ne couvre que les liens poses dans l'editeur de theme. Les liens ecrits dans
   les DESCRIPTIONS PRODUIT, les PAGES et les MENUS vivent cote admin, hors du theme :
   aucune case ne les atteint. Une regle generale les couvre tous, y compris ceux que
   Morgane ajoutera apres notre passage.

   CE QUI N'EST PAS TOUCHE, VOLONTAIREMENT
   - les liens INTERNES (meme domaine, sous-domaines, et le domaine technique
     .myshopify.com de la boutique) : ils doivent rester dans l'onglet courant ;
   - mailto:, tel:, les ancres (#) et javascript: ;
   - un lien qui porte DEJA un target choisi a la main : on ne le contredit pas.

   SECURITE — rel="noopener noreferrer" est pose en meme temps. Sans « noopener », la
   page ouverte garde une reference vers la fenetre de la boutique (window.opener) et
   peut la rediriger : c'est une vraie faille, pas une precaution de style.

   ACCESSIBILITE — le changement d'onglet n'est PAS annonce aux lecteurs d'ecran :
   il faudrait modifier les libelles, au risque de defigurer ceux que Morgane a
   rediges. Choix assume, a rouvrir si le sujet devient un critere. */
(function () {
  'use strict';

  if (window.__naudetLiensExternes) return;
  window.__naudetLiensExternes = true;

  var hote = (window.location.hostname || '').toLowerCase();
  var morceaux = hote.split('.');
  /* domaine racine : « naudet.com » pour « maison.naudet.com » */
  var racine = morceaux.length > 2 ? morceaux.slice(-2).join('.') : hote;

  function estInterne(a) {
    var h = (a.hostname || '').toLowerCase();
    if (!h) return true; /* lien relatif ou ancre */
    if (h === hote || h === racine) return true;
    if (racine && h.slice(-(racine.length + 1)) === '.' + racine) return true;
    if (h.slice(-14) === '.myshopify.com') return true;
    return false;
  }

  function marquer(a) {
    var p = (a.protocol || '').toLowerCase();
    if (p !== 'http:' && p !== 'https:') return; /* mailto:, tel:, javascript: */
    if (estInterne(a)) return;

    var cible = a.getAttribute('target');
    if (cible && cible !== '_self') return; /* choix explicite deja fait : on respecte */

    a.setAttribute('target', '_blank');

    var rel = (a.getAttribute('rel') || '').split(/\s+/);
    var propre = [];
    for (var i = 0; i < rel.length; i++) {
      if (rel[i] && propre.indexOf(rel[i]) === -1) propre.push(rel[i]);
    }
    if (propre.indexOf('noopener') === -1) propre.push('noopener');
    if (propre.indexOf('noreferrer') === -1) propre.push('noreferrer');
    a.setAttribute('rel', propre.join(' '));

    a.setAttribute('data-naudet-externe', '');
  }

  function traiter(noeud) {
    if (!noeud || noeud.nodeType !== 1) return;
    if (noeud.tagName === 'A' && noeud.hasAttribute('href')) marquer(noeud);
    if (!noeud.querySelectorAll) return;
    var liens = noeud.querySelectorAll('a[href]');
    for (var i = 0; i < liens.length; i++) marquer(liens[i]);
  }

  function demarrer() {
    traiter(document.body || document.documentElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* Le theme re-rend des sections entieres apres coup : choix d'une variante, ajout
     rapide, filtres de collection, sous-menus. Sans observateur, les liens reinjectes
     repartiraient sans target — le defaut reviendrait par la fenetre. On ne traite que
     les noeuds AJOUTES, pas tout le document, pour ne rien couter en defilement. */
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var ajouts = mutations[i].addedNodes;
        for (var j = 0; j < ajouts.length; j++) traiter(ajouts[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
